import { SelectOptions } from '@spo/logic';
import { useTranslation } from 'react-i18next';
import Select, { InputActionMeta } from 'react-select';
import './selectionInput.scss';

export interface SelectionInputProps {
  entities: SelectOptions[] | undefined;
  selectedEntity: number | null;
  entityType: 'sport' | 'nature' | 'usage-segmentation' | 'product-benefit';
  handleEntitySelection: (entity: number) => void;
  onInputChange?: (search: string, actionMeta: InputActionMeta) => void;
  isSelectDisabled?: boolean;
  architecture?: boolean;
  hideLabel?: boolean;
  placeholder?: string;
}

export const SelectionInput = ({
  entities,
  selectedEntity,
  entityType,
  handleEntitySelection,
  onInputChange,
  isSelectDisabled = false,
  architecture = false,
  hideLabel = false,
  placeholder,
}: SelectionInputProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="selection-input-space"
      data-testid={`${entityType}-selection_input-space`}
    >
      {!hideLabel && (
        <div className="input-label">{t(`input.${entityType}_label`)}</div>
      )}
      {!architecture && entityType === 'sport' && entities?.length === 1 ? (
        <input
          className="default-selected"
          data-testid="default-selected"
          value={entities[0].name}
          disabled
        />
      ) : (
        <Select
          menuPlacement="auto"
          data-testid="offer-poster_selected"
          aria-label={
            t(`select.${entityType}_placeholder`) || `Select a ${entityType}`
          }
          placeholder={placeholder || t(`select.${entityType}_placeholder`)}
          value={entities?.filter((entity) => entity.value === selectedEntity)}
          onChange={(entity) => entity && handleEntitySelection(entity.value)}
          isSearchable
          hideSelectedOptions={false}
          onInputChange={onInputChange}
          options={entities}
          id={`${entityType}-selection`}
          isDisabled={isSelectDisabled}
          styles={{
            control: (provided) => ({
              ...provided,
              cursor: 'pointer',
            }),
          }}
          menuPosition="fixed"
        />
      )}
    </div>
  );
};
